import styled from 'styled-components';
import { themeSize } from '../../../../theme/getters';
import { Carousel } from '../../../../shared/components/carousel';

export const Container = styled.div`
  width: 150%;
`;

export const PaddingWrapper = styled.div`
  padding-left: ${themeSize('contentPadding')}px;
`;

export const Slider = styled(Carousel)`
  .slick-track {
    display: flex;
    align-items: flex-start;
  }
`;

export const OverflowWrapper = styled.div`
  overflow: hidden;
  width: calc(100% + ${themeSize('contentPadding')}px + ${themeSize('contentPadding')}px);
  margin-left: -${themeSize('contentPadding')}px;
`;
